module.exports = __webpack_public_path__ + "img/hat-cowboy-side.28161480.svg";